<template>
  <div class="content">
    <div class="content-top">
      <div :class="type == 1? 'active' : ''" style="margin-right: 14px" @click="changeType(1)">综合统计</div>
      <div :class="type == 2? 'active' : ''" @click="changeType(2)">进出统计</div>
    </div>
    <div class="content-box">
      <all-count v-if="type == 1"></all-count>
      <in-out-count v-else-if="type == 2"></in-out-count>
    </div>
  </div>
</template>

<script>
  import allCount from './components/allCount.vue'
  import inOutCount from './components/inOutCount.vue'
  export default {
    components: {
      allCount,
      inOutCount
    },
    data() {
      return {
        type: 1
      }
    },
    created() {
      
    },
    methods: {
      changeType(type){
        this.type = type
      }
    },
  }
</script>

<style scoped>
.content{
  padding: 1vw 1vh;
}
.content-top{
  height: 56px;
  border-radius: 6px;
  background: #FFFFFF;
  padding: 16px 18px;
  display: flex;
}
.content-top > div{
  font-size: 16px;
  color: #666;
  cursor: pointer;
  padding-bottom: 38px;
}
.active{
  border-bottom: 2px solid #0D3A95;
}
.content-box{
  height: calc(100% - 1vh - 56px);
}
</style>